import { useEffect, useState } from 'react';

// Matches Tailwind's `md` breakpoint, so `useIsMobile()` is true exactly when `md:` styles
// are not applied.
const MOBILE_QUERY = '(max-width: 767px)';

/**
 * Tracks whether the viewport is below the `md` breakpoint.
 *
 * Exists so a layout can choose which tree to *mount* rather than relying on `md:hidden` to
 * hide one with CSS. Hidden-but-mounted trees still run every effect, websocket subscription
 * and interval they contain, which is invisible on screen but very expensive.
 */
export function useIsMobile(): boolean {
  // Read synchronously so the first render already commits the correct tree; deciding on a
  // later effect would mount one layout and immediately tear it down.
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(MOBILE_QUERY).matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_QUERY);
    const handleChange = (event: MediaQueryListEvent) => setIsMobile(event.matches);

    setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return isMobile;
}

export default useIsMobile;
